module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Abbreviations")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("AB")]), _vm._v("Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("ABRL")]), _vm._v("Anchor Bible Reference Library")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("ATR")])]), _c('em', [_vm._v("Australasian Theological Review")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("BECNT")]), _vm._v("Baker Exegetical Commentary on the New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("BTB")])]), _c('em', [_vm._v("Biblical Theology Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("BZNW")]), _vm._v("Beihefte zur Zeitschrift für neutestamentliche Wissenschaft")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("CBQ")])]), _c('em', [_vm._v("Catholic Biblical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("CTR")])]), _c('em', [_vm._v("Criswell Theological Review")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("DJG")])]), _c('em', [_vm._v("Dictionary of Jesus and the Gospels")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("HKAT")]), _vm._v("Handkommentar zum Alten Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("ICC")]), _vm._v("International Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("Int")])]), _c('em', [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("JBL")])]), _c('em', [_vm._v("Journal of Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("JR")])]), _c('em', [_vm._v("Journal of Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("JSNTSup")]), _vm._v("Journal for the Study of the New Testament: Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("JTS")])]), _c('em', [_vm._v("Journal of Theological Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("NCB")]), _vm._v("New Century Bible")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("NIGTC")]), _vm._v("New International Greek Testament Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("NovT")])]), _c('em', [_vm._v("Novum Testamentum")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("NTL")]), _vm._v("New Testament Library")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("NTS")])]), _c('em', [_vm._v("New Testament Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("NTTS")]), _vm._v("New Testament Tools and Studies")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("SBLSP")])]), _c('em', [_vm._v("Society of Biblical Literature Seminar Papers")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("SBLSBS")]), _vm._v("Society of Biblical Literature Sources for Biblical Studies")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("SBT")]), _vm._v("Studies in Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("TDNT")])]), _c('em', [_vm._v("Theological Dictionary of the New Testament. Edited by G. Kittel and G. Friedrich. Translated by G. W. Bromiley. 10 vols. Grand Rapids, 1964–1976.")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("TNTC")]), _vm._v("Tyndale New Testament Commentaries")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_c('em', [_vm._v("TS")])]), _c('em', [_vm._v("Theological Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("WBC")]), _vm._v("Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abbre-para"
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("WUNT")]), _vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])]), _c('p', {
    staticClass: "abbre-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "abbre"
  }, [_vm._v("ZNW")]), _vm._v("Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eee5af2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Abbreviation.vue
// module id = 78
// module chunks = 0